module.exports = __webpack_public_path__ + "img/thumbnail_TasmanianDevil_f_normal.010c17f9.png";